<template>
  <div class="disease-risk">
    <div class="disease-title">患病风险倍数</div>
    <canvas
      class="canvas-container"
      ref="riskRef"
      width="600"
      height="450"
    ></canvas>
    <ul class="risk-info">
      <li class="item">
        您可能的终身患病风险
        <span class="s1">{{ riskData.rate }}%</span>
      </li>
      <li class="item">
        中国人平均终身患病风险
        <span class="s3">{{ riskData.chineseRisk }}%</span>
      </li>
      <li class="item">
        您患病风险为中国人平均值的
        <span class="s2">{{ riskData.risk }}倍</span>
      </li>
    </ul>

    <div class="disease-title">人群占比</div>
    <canvas
      class="canvas-container"
      ref="scaleRef"
      width="600"
      height="450"
    ></canvas>
    <ul class="scale-info">
      <li class="item red">
        <i class="rect"></i>
        患病概率比您高的人群占：{{ scaleData.up_rate }}%
      </li>
      <li class="item yellow">
        <i class="rect"></i>
        患病概率跟您相同的人群占：{{ scaleData.same_rate }}%
      </li>
      <li class="item blue">
        <i class="rect"></i>
        患病概率比您低的人群占：{{ scaleData.low_rate }}%
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      // 风险评估数据
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      main: "",
      max: "",
      multiple: 3, // 3倍缩放， 使 canvas 更清晰
    };
  },
  methods: {
    drawRisk() {
      // 倍率绘制
      let riskRef = this.$refs.riskRef;
      let ctx = riskRef.getContext("2d");
      let start = this.getRiskStart;
      let end = this.getRiskEnd;
      let multiple = this.multiple; // 放大倍率
      // 表盘中心
      let cx = 100 * multiple; // 表盘的中心x （也是绿色圈的中心）
      let cy = 115 * multiple; // 表盘的中心y （也是绿色圈的中心）
      let cr1 = 70 * multiple; // 表盘的半径
      let cr = 24 * multiple; // 绿色圈半径
      let color = this.getChartColor; //中间圆圈颜色
      /*文字(包括左右和中间圆形中文字)上下左右居中 */
      ctx.font = 14 * multiple + "px Arial";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillStyle = "#F84A2A";
      /*环形最大值与最小值,被注释的是指针的值*/
      ctx.fillText(start, cx - cr1, 140 * multiple);
      ctx.fillText(end, cx + cr1, 140 * multiple);
      ctx.fillStyle = color; //圆形颜色

      /**指针配置 */
      ctx.beginPath();
      ctx.arc(cx, cy, cr, 0, 2 * Math.PI);
      ctx.fill();
      ctx.fillStyle = "#fff"; //圆形文字颜色
      ctx.fillText(this.getCurrentRisk, cx, cy);

      // 弧形渐变表盘
      ctx.beginPath();
      let gradient = ctx.createLinearGradient(0, 0, 200 * multiple, 0);
      gradient.addColorStop("0", "#00A8DF");
      gradient.addColorStop("0.5", "#76CC16");
      gradient.addColorStop("1.0", "#F84A2A");
      // 用渐变进行填充
      ctx.strokeStyle = gradient;
      ctx.lineWidth = 4 * multiple;
      ctx.arc(cx, cy, cr1, 1 * Math.PI, 0, false);
      ctx.stroke();

      // 表针
      ctx.beginPath();
      ctx.strokeStyle = color;
      let deg =
        (((this.getCurrentRisk - 1) / (this.getRiskEnd - 1)) * Math.PI) / 2 +
        Math.PI / 2;
      let RealDeg = Math.PI - deg;
      let width = cr1 - 5 * multiple;
      let x = cx + Math.cos(RealDeg) * width;
      let y = cy - Math.sin(RealDeg) * width;
      let x1 = cx + ((cr + 5) * (x - cx)) / width;
      let y1 = cy - ((cr + 5 * multiple) * (cy - y)) / width;

      ctx.lineWidth = 2 * multiple;
      ctx.moveTo(x, y); //圆心值
      ctx.lineTo(x1, y1);
      ctx.stroke();
    },
    drawScale() {
      let multiple = this.multiple;
      let scaleRef = this.$refs.scaleRef;
      let ctx = scaleRef.getContext("2d");
      let cx = scaleRef.width / 2;
      let cy = scaleRef.height / 2;
      let cr = 70 * multiple;
      let sicknessRate = this.sicknessRate;
      let startDeg = 0; // 存放每次的起始角度
      let color = ["#FA564D", "#FEB500", "#00C0EE"];
      ctx.font = 14 * multiple + "px Arial";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      let endDegs = [];
      for (let i = 0, len = sicknessRate.length; i < len; i++) {
        ctx.fillStyle = color[i];
        let endDeg = (sicknessRate[i] / 100) * 2 * Math.PI;
        endDegs.push(endDeg);
        ctx.beginPath();
        ctx.moveTo(cx, cy);
        ctx.arc(cx, cy, cr, startDeg, startDeg + endDeg, false);
        ctx.fill();
        startDeg = startDeg + endDeg;
      }
    },
    clear() {
      let riskRef = this.$refs.riskRef;
      let ctx = riskRef.getContext("2d");
      ctx.clearRect(0, 0, 600, 450); //给定矩形内清空样式
      let scaleRef = this.$refs.scaleRef;
      let ctx1 = scaleRef.getContext("2d");
      ctx1.beginPath();
      ctx1.clearRect(0, 0, 600, 450);
    },
    formatMath(val, num) {
      // 保留两位小数
      return val.toFixed(num);
    },
  },
  computed: {
    riskData() {
      // 中国人平均风险
      const risk = this.data.risk; // 倍率
      const rate = this.data.rate; // 风险
      const data = {
        risk: this.formatMath(Number(risk), 3),
        rate: this.formatMath(Number(rate * 100), 4),
        chineseRisk: this.formatMath((rate / risk) * 100, 3),
      };
      return data;
    },
    scaleData() {
      return {
        up_rate: this.formatMath(Number(this.data.up_rate * 100), 2),
        same_rate: this.formatMath(Number(this.data.same_rate * 100), 2),
        low_rate: this.formatMath(Number(this.data.low_rate * 100), 2),
      };
    },
    getRiskStart() {
      // 风险起始点
      return this.data.min_risk;
    },
    getRiskEnd() {
      // 风险结束点
      return this.data.max_risk;
    },
    getChartColor() {
      const level = this.data.conclusion;
      if (level === "高风险" || level === "较高风险") {
        return "#F84A2A"; //红色
      } else if (level === "一般风险") {
        return "#76CC16"; //绿色
      } else {
        return "#00A8DF"; //蓝色
      }
    },
    getCurrentRisk() {
      // 当前风险倍率
      return this.data.risk;
    },
    sicknessRate() {
      // 占比比例
      let upRate = this.data.up_rate * 100;
      let sameRate = this.data.same_rate * 100;
      let lowRate = this.data.low_rate * 100;
      return [upRate, sameRate, lowRate];
    },
  },
  watch: {
    data: function () {
      this.clear();
      this.drawRisk();
      this.drawScale();
    },
  },
};
</script>

<style lang="scss" scoped>
.disease-risk {
  padding: 15px;
  .disease-title {
    font-size: 0.16rem;
    position: relative;
    padding-left: 0.15rem;
  }
  .disease-title::before {
    content: "";
    position: absolute;
    left: 0;
    top: 5px;
    width: 10px;
    height: 10px;
    border-radius: 10px;
    background-color: rgb(128, 186, 65);
  }
  .canvas-container {
    margin: 0 auto;
    display: block;
    width: 2rem;
  }
  .risk-info {
    padding: 2em 0 2em 0.6rem;
    .item {
      // font-size: 0.13rem;
      .s1,
      .s2,
      .s3 {
        font-size: 1.2em;
      }
      .s1 {
        color: #fb7376;
      }
      .s2 {
        color: #7c70b9;
      }
      .s3 {
        color: #0090af;
      }
    }
  }
  .scale-info {
    padding: 2em 0 2em 0.6rem;
    .red {
      color: #fb7376;
      .rect {
        background: #fb7376;
      }
    }
    .yellow {
      color: #feb500;
      .rect {
        background: #feb500;
      }
    }
    .blue {
      color: #00c0ee;
      .rect {
        background-color: #00c0ee;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/smallGlobal/content/ContentRisk.vue